module.exports = __webpack_public_path__ + "img/26.54201616.jpg";